export class DataRequestItem {

  title: string;
  subtitle: string | null;
  unitPrice: number;
  quantity: number;
  mrcId: string | null;
  description: string | null;
  dateAvailability: string | null;
  formats: string | null;
  type: DataRequestItemType;
}

export enum DataRequestItemType {
  TIME_SERIES = "TIME_SERIES",
  GEOSPATIAL = "GEOSPATIAL",
  SECTORAL = "SECTORAL",
  DOCUMENT = "DOCUMENT",
}

export class DataRequest {
  licenseRequired: boolean;
  login: string;
  organisation: string | null;
  firstName: string;
  lastName: string;
  address: string;
  country: string;
  province: string;
  city: string;
  zipPostalCode: string;
  email: string;
  items: DataRequestItem[];


}

export class DataRequestResponse {
  url: string | null;
  success: boolean;
}

export class BcelDataRequestResponse {
  amount: string;
  access_key: string;
  profile_id: string;
  transaction_uuid: string;
  signed_date_time: string;
  locale: string;
  transaction_type: string;
  reference_number: string;
  currency: string;
  bill_to_forename: string;
  bill_to_surname: string;
  bill_to_email: string;
  signed_field_names: string;
  signature: string;
  success: boolean;
  bill_to_address_line1: string;
  bill_to_address_city: string;
  bill_to_address_country: string;
  bill_to_address_state: string;
  bill_to_address_postal_code: string;
}





